export default __webpack_public_path__ + "static/media/pic4.3584c4f5.png";